import ipadglass from '../../assets/muvtech/Muvdata/ipadGlass/ProShield11-13pro.png';

const ipadglassData = [
  {
    id: 1,
    type: 'ipadglass',
    title: 'Pro Shield Glass',
    compatibleModels: 'iPad 10.2 to 13 Pro',
    price: 2199,
    specs: [],
    image: [ipadglass],
  },
];

export default ipadglassData;
